import { gql } from '@apollo/client';

export const MUTATION_CREATE_OR_UPDATE_USER_PREFERENCE = gql`
    mutation CreateOrUpdateUserPreferences($data: UserPreferencesInput!) {
        createOrUpdateUserPreferences(data: $data) {
            componentKey
            id
            isDefault
            name
            preferenceData
        }
    }
`;
